class VideoPlayer {

  static initializedClass = 'initialized';

  static init() {
    document
      .querySelectorAll(`.video-player:not(.${this.initializedClass})`)
      .forEach((element) => new this(element));
  }

  constructor ( wrapper ) {
    this.wrapper = wrapper;
    this.video = wrapper.querySelector('video');
    this.playButton = wrapper.querySelector('button');
    if ( !this.video || !this.playButton ) {
      return;
    }
    this.wrapper.classList.add( this.constructor.initializedClass );
    this.bindEvents();
  }

  bindEvents() {
    this.playButton.addEventListener( 'click', () => {
      this.video.play();
    });

    this.video.addEventListener( 'playing', () => {
      this.video.controls = true;
      this.playButton.classList.add( 'hidden' );
    });
  }
}

VideoPlayer.init();